import { useMemo } from "react";

import { getPlannerDataPrepStatus } from "fond/project/panels/ExtendedDesign/DataPrep/plannerDataPrepStatus";
import { DataPrepStatus } from "fond/project/panels/RunDataPrep/dataPrepStatus";
import { Maybe } from "fond/types";

import { useGetPlannerLayers } from "./useGetPlannerLayers";

/** Return the status of layer groups relevant to planner data prep */
export const usePlannerDataPrepStatus = (versionId: Maybe<string>): DataPrepStatus => {
  const { layerKeys } = useGetPlannerLayers(versionId);
  return useMemo(() => getPlannerDataPrepStatus(layerKeys), [layerKeys]);
};
